import {
  BoldedLabel,
  InputContainer,
  AutoInputContainer,
  MiniInputContainer,
} from "components/components/Dropdown/style";
import React, { ChangeEvent } from "react";

import { StyledInput } from "./style";

interface Props {
  selectedValue: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  size?: "mini" | "auto";
}

const InputBox: React.FC<Props> = ({
  selectedValue,
  onChange,
  placeholder,
  label,
  size,
}) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.value);
  };

  const containerMap: Record<string, React.ElementType> = {
    mini: MiniInputContainer,
    auto: AutoInputContainer,
  };

  const Container: React.ElementType = size
    ? containerMap[size]
    : InputContainer;

  return (
    <Container>
      {label && <BoldedLabel>{label}</BoldedLabel>}
      <StyledInput
        type="text"
        value={selectedValue}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    </Container>
  );
};

export default InputBox;
